import { Moon, Sun } from 'lucide-react';
import { motion } from 'motion/react';

import { Button } from '@core/components/Button';
import { useDarkMode } from '@core/hooks/useDarkMode';
import { cn } from '@core/utils/styles';

export function ThemeButton({ className }: { className?: string }) {
  const { theme, toggleTheme } = useDarkMode();

  return (
    <Button
      variant="outline"
      size="icon"
      className={cn(
        'group bg-back-light/75 dark:bg-back-light/20 text-txt-light dark:text-txt-dark relative mx-auto size-10 rounded-full',
        className
      )}
      onClick={toggleTheme}
    >
      <motion.div className="from-primary-dark dark:from-primary-lightest to-secondary-dark dark:to-secondary-light absolute inset-0 flex items-center justify-center bg-gradient-to-br opacity-0 blur-lg transition-all duration-500 group-hover:opacity-100 group-data-focus:opacity-100" />

      <motion.div
        animate={{
          x: theme === 'dark' ? -100 : 0,
          opacity: theme === 'dark' ? 0 : 1,
        }}
        className="absolute"
      >
        <Sun className="size-5 transition-all duration-500" />
      </motion.div>

      <motion.div
        animate={{
          x: theme === 'light' ? -100 : 0,
          opacity: theme === 'light' ? 0 : 1,
        }}
        className="absolute"
      >
        <Moon className="size-5 transition-all duration-500" />
      </motion.div>
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
